module.exports = __webpack_public_path__ + "img/utilityvalvac_stopped.5aca99c1.svg";